import client from '@/api/managerApi';

export default {
    getSmsBalance() {
        return client.get('notifications/sms-balance');
    }
};
